import React from "react"
import { Title, Link, Meta } from "react-head"

const Head = ({
  title = "Узнайте, на что вы готовы ради Еды!",
  logo = "/images/backgroundMain.png",
  Description = "Мобильное приложение телеканала Еда",
  slug,
}: any) => {
  return (
    <>
      <Meta charSet="utf-8" />
      <base href="/" />
      <Title>{title}</Title>
      <Meta name="Description" content={Description} />

      <Meta property="og:image" content={"//gotov.tveda.ru" + logo} />
      <Meta property="og:url" content={"http://gotov.tveda.ru/" + slug} />

      <Meta property="og:type" content="article" />
      <Meta property="og:title" content={title} />
      <Meta property="og:description" content={Description} />

      <Meta name="twitter:title" content={title} />
      <Meta name="twitter:description" content={Description} />
      <Meta name="twitter:image" content={"//gotov.tveda.ru" + logo} />
      <Meta name="twitter:card" content="summary_large_image" />

      <script
        dangerouslySetInnerHTML={{
          __html: `
              (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(16950151, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
        `,
        }}
      />
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=UA-38627115-1"
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
                 window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'UA-38627115-1');
        `,
        }}
      />
      <Link
        rel="apple-touch-icon"
        sizes="57x57"
        href="/favicon/apple-icon-57x57.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="60x60"
        href="/favicon/apple-icon-60x60.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="72x72"
        href="/favicon/apple-icon-72x72.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="76x76"
        href="/favicon/apple-icon-76x76.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="114x114"
        href="/favicon/apple-icon-114x114.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="120x120"
        href="/favicon/apple-icon-120x120.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="144x144"
        href="/favicon/apple-icon-144x144.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="152x152"
        href="/favicon/apple-icon-152x152.png"
      />
      <Link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/favicon/apple-icon-180x180.png"
      />
      <Link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href="/favicon/android-icon-192x192.png"
      />
      <Link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon/favicon-32x32.png"
      />
      <Link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href="/favicon/favicon-96x96.png"
      />
      <Link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon/favicon-16x16.png"
      />
      <Link rel="manifest" href="/favicon/manifest.json" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta
        name="msapplication-TileImage"
        content="/favicon/ms-icon-144x144.png"
      />
      <meta name="theme-color" content="#ffffff" />
    </>
  )
}

export default Head
